module.exports = __webpack_public_path__ + "static/img/bcg.df4fdc1a.webp";